module.exports = __webpack_public_path__ + "img/banner_ongoing_JP.c5d9c54d.png";